module.exports = __webpack_public_path__ + "img/5.88c4a9d.png";